import React from 'react';
import { Link } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form, Table, Row, Col, Button, Badge, Panel } from 'react-bootstrap';
import { FormActions, Static } from '../../common/components/formControls';
import { withTranslation } from 'react-i18next';
import ui from '../../common/services/ui';
import utils from '../../common/services/utils';
import { ConfirmationButton } from '../../common/components/formControls';
import BackButton from '../../common/components/BackButton';
import Notes from '../notes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDollar } from '@fortawesome/free-solid-svg-icons';

const SettingsForm = ({ error, handleSubmit, pristine, submitSucceeded, initialValues, lessons, canViewNotes,
	canCancelLesson, cancelLesson, cancelAndRefundLesson, parentId, cancelAllLessons, cancelAndRefundEnrolment, restoreCancelledLesson,
	deleteAutoEnrolment, enableAutoEnrolment, hasDeleteAutoEnrolmentPermission, t }) => {

	let allowRefund = initialValues && initialValues.status.id === 2;
	let isAutoEnrolment = enableAutoEnrolment && initialValues && initialValues.isAutoEnrolment;
	let lessonRows = [];
	let hasNoCanceledLessons = lessons ? lessons.filter(l => !l.canceled).length > 0 : false;

	if (lessons) {
		lessonRows = lessons.map(lesson => (
			<tr key={lesson.lessonDate}>
				<td>{ui.formatDate(lesson.lessonDate)}</td>
				<td>{ui.formatTime(utils.parseTime((lesson.startTime || initialValues.startTime)))} - {ui.formatTime(utils.parseTime(lesson.endTime || initialValues.endTime))}</td>
				<td>{lesson.isAttended ? <Badge bsStyle='success'>{t('Enrolment_Attended')}</Badge> : ''} {lesson.canceled ? <Badge bsStyle='warning'>{t('Enrolment_Canceled')}</Badge> : ''}</td>
				{canCancelLesson && <td>
					{lesson.canceled && <ConfirmationButton bsStyle='warning' displayType='inline-block' style={{ marginBottom: '5px', marginRight: '5px' }}
						onConfirmation={() => restoreCancelledLesson(lesson.id)}
						confirmationTitle={t('PaymentHistory_RestoreCancelledLessonConfirmationTitle')}
						confirmationMessage={t('PaymentHistory_RestoreCancelledLessonConfirmationMessage', { lesson_date: ui.formatDate(lesson.lessonDate) })}
						label={t('PaymentHistory_RestoreCancelledLesson')}
					/>}
					{!lesson.canceled && <ConfirmationButton bsStyle='warning' displayType='inline-block' style={{ marginBottom: '5px', marginRight: '5px' }}
						onConfirmation={() => cancelLesson(lesson.id)}
						confirmationTitle={t('PaymentHistory_CancelLessonConfirmationTitle')}
						confirmationMessage={t('PaymentHistory_CancelLessonConfirmationMessage', { lesson_date: ui.formatDate(lesson.lessonDate) })}
						label={t('PaymentHistory_CancelLesson')}
					/>}
					{allowRefund && <Button bsStyle='danger' onClick={() => cancelAndRefundLesson(lesson.id, lesson.lessonDate)}><FontAwesomeIcon icon={faDollar} /> {t('PaymentHistory_CancelAndRefundLesson')}</Button>}
				</td>}
			</tr>)
		);
	}

	const gradeRow = initialValues && <div>
		{initialValues.name || initialValues.grade.name} ({t(ui.days[initialValues.dayOfWeek])} {ui.formatTime(utils.parseTime(initialValues.startTime))})
		{initialValues.name && initialValues.grade && initialValues.grade.name && <div className='text-muted'>{initialValues.grade.name}</div>}
	</div>;
	const paymentType = initialValues && t(`PaymentTypeEnum_${initialValues.paymentType.name}`);
	const quantity = initialValues && `${initialValues.quantity}${initialValues.refundedQuantity ? ', ' + t('PaymentHistory_QuantityRefunded') + ' ' + initialValues.refundedQuantity : ''}`;
	const idRow = initialValues && <div>{initialValues.id} &gt; <Link to={`/paymentHistory/${initialValues.paymentId}`}>View order</Link></div>;
	const childId = initialValues && initialValues.child.id;
	parentId = parentId || (initialValues && initialValues.parent.id);

	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			<Row>
				<Col sm={6}>
					<Panel>
						<Panel.Heading>{t('PaymentHistory_Enrolment')}</Panel.Heading>
						<Panel.Body>
							<Field name='id' component={Static} labelSize={4} horizontal label={t('Enrolment_Id')} valueWrapper={value => <span>{idRow}</span>} />
							<Field name='center' component={Static} labelSize={4} horizontal label={t('PaymentHistory_Center')} />
							<Field name='grade' component={Static} labelSize={4} horizontal label={t('PaymentHistory_Grade')} valueWrapper={value => <span>{gradeRow}</span>} />
							<Field name='quantity' component={Static} labelSize={4} horizontal label={t('PaymentHistory_NumberOfHours')} valueWrapper={value => <span>{quantity} ({paymentType}){isAutoEnrolment && <Badge bsStyle='info' style={{ marginLeft: '5px' }}>{t('Enrolment_IsAutoEnrolment')}</Badge>}</span>} />
						</Panel.Body>
					</Panel>
				</Col>
				<Col sm={6}>
					<Panel>
						<Panel.Heading>{t('PaymentHistory_Parent')}</Panel.Heading>
						<Panel.Body>
							<Field name='parent.fullname' component={Static} labelSize={4} horizontal label={t('PaymentHistory_Parent')} valueWrapper={value => <Link to={`/parents/${parentId}`}>{value}</Link>} />
							<Field name='parent.email' component={Static} labelSize={4} horizontal label={t('Parent_Email')} />
							<Field name='parent.phoneNumber' component={Static} labelSize={4} horizontal label={t('PaymentHistory_PhoneNumber')} />
							<Field name='child.fullname' component={Static} labelSize={4} horizontal label={t('PaymentHistory_Child')} valueWrapper={value => <Link to={`/parents/${parentId}/children/${childId}`}>{value}</Link>} />
						</Panel.Body>
					</Panel>
				</Col>
			</Row>
			<Row>
				<Col sm={12}>
					<Panel>
						<Panel.Heading>{t('PaymentHistory_Lessons')}</Panel.Heading>
						<Panel.Body>
							<Table responsive>
								<tbody>
									{lessonRows}
								</tbody>
							</Table>
						</Panel.Body>
					</Panel>
				</Col>
			</Row>
			<Row>
				<Col sm={12}>
					{canViewNotes && <Panel>
						<Panel.Heading>{t('Enrolment_Section_Notes')}</Panel.Heading>
						<Panel.Body>
							<Notes reference={initialValues.id} referenceType='PaymentHistory' />
						</Panel.Body>
					</Panel>}
				</Col>
			</Row>



			<FormActions horizontal>
				<BackButton />
				<div className='pull-right'>
					{canCancelLesson && hasNoCanceledLessons && <ConfirmationButton bsStyle='warning' displayType='inline-block' style={{ marginLeft: '5px', marginRight: '5px', marginBottom: '5px' }}
						onConfirmation={cancelAllLessons}
						confirmationTitle={t('Enrolment_CancelAllLessonsConfirmationTitle')}
						confirmationMessage={t('Enrolment_CancelAllLessonsConfirmationMessage')}
						label={t('Enrolment_CancelLAllessons')}
					/>}
					{canCancelLesson && allowRefund && lessons && lessons.length > 0 && <Button className='pull-right' bsStyle='danger' onClick={cancelAndRefundEnrolment}><FontAwesomeIcon icon={faDollar} /> {t('Enrolment_CancelAndRefundAllLessons')}</Button>}
					{enableAutoEnrolment && hasDeleteAutoEnrolmentPermission && initialValues && initialValues.canDeleteAutoEnrolment && <ConfirmationButton bsStyle='danger' displayType='inline-block' style={{ marginLeft: '5px', marginRight: '5px', marginBottom: '5px' }}
						onConfirmation={deleteAutoEnrolment}
						confirmationTitle={t('Enrolment_DeleteAutoEnrolmentConfirmationTitle')}
						confirmationMessage={<div>
							<p>{t('Enrolment_DeleteAutoEnrolmentConfirmationMessage', { child: initialValues.child ? initialValues.child.fullname : '', count: lessons ? lessons.length : 0 })}</p>
							<p>{t('Enrolment_DeleteAutoEnrolmentConfirmationEmailNote')}</p>
						</div>}
						label={t('Enrolment_DeleteAutoEnrolment')}
					/>}
				</div>
			</FormActions>
		</Form>
	);
};

export default reduxForm({ form: 'enrolment', enableReinitialize: true })(withTranslation()(SettingsForm));
